import { render, staticRenderFns } from "./ExistingMediafile.vue?vue&type=template&id=3a672312&scoped=true&"
import script from "./ExistingMediafile.vue?vue&type=script&lang=js&"
export * from "./ExistingMediafile.vue?vue&type=script&lang=js&"
import style0 from "./ExistingMediafile.vue?vue&type=style&index=0&id=3a672312&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a672312",
  null
  
)

export default component.exports